export const DIALOG_WIDTH = 310;

export const DIALOG_WIDTH_WIDER = 325;



// WEBPACK FOOTER //
// ../../src/constants/dimensions.ts